import { render, staticRenderFns } from "./SwaggerUI.vue?vue&type=template&id=62bdb6b2&"
import script from "./SwaggerUI.vue?vue&type=script&lang=ts&"
export * from "./SwaggerUI.vue?vue&type=script&lang=ts&"
import style0 from "./SwaggerUI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports